type CreateImageBitmapWithOptions = (
  image: ImageBitmapSource,
  options?: ImageBitmapOptions,
) => Promise<ImageBitmap>;

const createImageBitmapWithOptions = createImageBitmap as CreateImageBitmapWithOptions;

const createImageBitmapFromFile = async (
  file: File,
  options?: ImageBitmapOptions,
): Promise<ImageBitmap> => {
  try {
    return await createImageBitmapWithOptions(file, options);
  } catch (error) {
    throw error ?? new Error("createImageBitmap failed");
  }
};

export default createImageBitmapFromFile;
